/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_06_Detail_Beginner_2_HeadingInputs */

const en_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built for the long game`)
};

const es_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pensado para el largo plazo`)
};

const de_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebaut für das lange Spiel`)
};

const zh_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为长久打球而设计`)
};

const ar_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مبني للمدى الطويل`)
};

const fr_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conçu pour le long jeu`)
};

const vi_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xây cho dài hạn`)
};

const sw_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imejengwa kwa ajili ya safari ndefu ya mchezo`)
};

const th_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างมาเพื่อการเล่นระยะยาว`)
};

const bs_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamišljeno za dugi rok`)
};

const ja_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`長いゲームのために造られる`)
};

const ko_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`긴 게임에 내장`)
};

const pt_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construído para o longo jogo`)
};

const it_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pensato per giocare a lungo`)
};

const sv_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byggd för det långa spelet`)
};

const nl_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebouwd voor het lange spel`)
};

const da_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bygget til det lange spil`)
};

const nb_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bygget til det lange spillet`)
};

const fi_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rakennettu pitkälle pelille`)
};

const pl_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gry Zbudowany na długo gry`)
};

const ru_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создан для долгой игры`)
};

const tr_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzun vade için tasarlandı`)
};

const hi_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लंबे खेल के लिए निर्मित`)
};

const id_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dirancang untuk jangka panjang`)
};

const ms_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibina untuk jangka panjang`)
};

const cs_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postaven pro dlouhou hru`)
};

const el_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Χτισμένο για το μακρύ παιχνίδι`)
};

const he_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`נבנה למשחק הארוך`)
};

const af_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebou vir die lang spel`)
};

const hu_method_content_step_06_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hosszú távra építve`)
};

/**
* | output |
* | --- |
* | "Built for the long game" |
*
* @param {Method_Content_Step_06_Detail_Beginner_2_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_06_detail_beginner_2_heading = /** @type {((inputs?: Method_Content_Step_06_Detail_Beginner_2_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_06_Detail_Beginner_2_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "de") return de_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "zh") return zh_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "ar") return ar_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "fr") return fr_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "vi") return vi_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "sw") return sw_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "th") return th_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "bs") return bs_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "ja") return ja_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "ko") return ko_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "pt") return pt_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "it") return it_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "sv") return sv_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "nl") return nl_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "da") return da_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "nb") return nb_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "fi") return fi_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "pl") return pl_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "ru") return ru_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "tr") return tr_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "hi") return hi_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "id") return id_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "ms") return ms_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "cs") return cs_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "el") return el_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "he") return he_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "af") return af_method_content_step_06_detail_beginner_2_heading(inputs)
	if (locale === "hu") return hu_method_content_step_06_detail_beginner_2_heading(inputs)
	return en_method_content_step_06_detail_beginner_2_heading(inputs)
});